import get from 'lodash/get';

const sectionSelector = path => state => get(state, path);

export { sectionSelector };
